import React, { Component } from 'react'

export class HowItworksMiddle3 extends Component {
    render() {
        return (
            <div>
                <label className="HWLastWords"> Have a question? </label>
                <label className="HWLastWords2"> We're here to help 24/7. Head to our FAQs or get in touch. </label>
            </div>
        )
    }
}

export default HowItworksMiddle3
